module.exports = __webpack_public_path__ + "static/media/balance_25000_50000.47e4d31c.png";